<template>
  <div>
    <vue-base-dialog :dialogConfig="dialogConfig" class="selfCreateDialog">
      <div v-if="this.dialogConfig.data" class="dialog-content">
        <img
          v-if="this.dialogConfig.data && this.dialogConfig.data.photo"
          :src="this.dialogConfig.data.photo"
          alt=""
          class="photo"
        />
        <p class="name">{{ this.dialogConfig.data.name }}</p>
        <p class="abstract">{{ this.dialogConfig.data.abstract }}</p>
        <table>
          <tr>
            <td>答题次数:</td>
            <td class="right-td">
              {{ this.dialogConfig.data.limit_type == 0 ? "不限" : "单次" }}
            </td>
          </tr>
          <tr>
            <td>总分:</td>
            <td class="right-td">{{ this.dialogConfig.data.total_score }}分</td>
          </tr>
          <tr>
            <td>合格分数:</td>
            <td class="right-td">{{ this.dialogConfig.data.fit_score }}分</td>
          </tr>
          <tr>
            <td>题数:</td>
            <td class="right-td">{{ this.dialogConfig.data.total_num }}题</td>
          </tr>
          <tr>
            <td>测评开始时间:</td>
            <td class="right-td">{{ this.dialogConfig.data.start_time }}</td>
          </tr>
          <tr>
            <td>测评结束时间:</td>
            <td class="right-td">{{ this.dialogConfig.data.end_time }}</td>
          </tr>
        </table>
        <!-- <p class="note">
          注：限时测评在学生开始测评后计时开始，计时结束后，系统将自动提交测评结果，中途关闭测评页面计时不暂停。
        </p> -->
        <a-button
          class="button"
          type="primary"
          shape="round"
          @click="startAssess()"
          >开始测评</a-button
        >
      </div>
    </vue-base-dialog>
  </div>
</template>

<script>

import VueBaseDialog from "@/components/VueBaseDialog";
import services from "../../../config/services";
import { mapActions, mapState } from "vuex";
export default {
  name: "assessInfo",
  props: {
    dialogConfig: {
      type: Object,
    },
  },
  components: {
    VueBaseDialog,
  },
  data() {
    return {
      services: services,
      ass_id: 0,
      assessName: "",
      limit_time: 0,
    };
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  methods: {
    //取消关闭窗口
    cancel() {
      this.$emit("cancleDialog", null);
    },
    //开始测评
    startAssess() {
      this.ass_id = this.dialogConfig.data.id;
      this.assessName = this.dialogConfig.data.name;
      this.$router.push({path: `/${this.loginUserInfo && this.loginUserInfo.school_code}/user/myAssess/assessAnswer`,
        query: {
          ass_id: this.ass_id,
          class_id: this.dialogConfig.data.class_id,
          assessName: this.assessName,
          end_time: this.dialogConfig.data.end_time,
          tabs: 0,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-content {
  padding: 20px 70px;
  width: 565px;
}
.photo {
  max-width: 300px;
  height: auto;
}
.name {
  color: #14202c;
  font-size: 16px;
  font-weight: bold;
  margin: 10px auto;
}
.abstract {
  margin: 10px auto;
  color: #666666;
  text-align: left;
  word-wrap: break-word;
}
table {
  width: 100%;
  margin: 10px auto;
  color: #333;
}
table tr td:first-child {
  text-align: right;
  width: 40%;
}
.note {
  color: #fab863;
}
.button {
  border-radius: 3px;
  margin-top: 10px;
}
.button:hover {
  background: #134bce;
}
.right-td {
    padding-left: 60px;
    text-align: left;
}
</style>